module.exports = __webpack_public_path__ + "img/Flag_of_Barbados (1).68cbe434.svg";